import type { PropsWithChildren } from 'react';
import { Button } from 'antd';
import type { DrawerProps, ModalProps } from 'antd';

/** Existing business forms keep their validation and submit handlers in the Agent side panel. */
export function InlineDrawerFrame({
  visible,
  title,
  children,
  footer,
}: PropsWithChildren<DrawerProps>) {
  if (visible === false) return null;
  return (
    <section className="min-w-0 overflow-auto p-4">
      <h3>{title}</h3>
      {children}
      <footer className="flex gap-2 mt-4">{footer}</footer>
    </section>
  );
}
export function InlineModalFrame({
  visible,
  title,
  children,
  footer,
  onOk,
  onCancel,
  okText,
  cancelText,
  okButtonProps,
  confirmLoading,
}: PropsWithChildren<ModalProps>) {
  if (visible === false) return null;
  return (
    <section className="min-w-0 overflow-auto p-4">
      <h3>{title}</h3>
      {children}
      <footer className="flex gap-2 mt-4">
        {footer !== undefined ? (
          footer
        ) : (
          <>
            <Button type="primary" loading={confirmLoading} {...okButtonProps} onClick={onOk}>
              {okText}
            </Button>
            <Button onClick={onCancel}>{cancelText}</Button>
          </>
        )}
      </footer>
    </section>
  );
}
